import { Col, Divider, Form, Row, Select } from "antd";
import React, { Fragment } from "react"
import { setAlizFinishingEqualMarco } from "../../../../suport-files/proposal-functions.jsx";
import {
    ADJUSTABLE_FACE,
    ALIZ_RELATION_KEYS,
    FIXED_FACE,
    getAlizSectionValues,
    hasAlizPanelOptions,
    resolveAlizComponentMatch,
} from "../../../../suport-files/alizar-matriz-helpers.js";

const productStepAlizar = ({
    index,
    getProductValue,
    updateProductData,
    getPatternOfFinishingsComponent,
    getPatternOfAFinishing,
    filterComponentBySheetFinishing,
    _this,
}) => {
    const getMarcoThicknessInfo = (id, attr) => {
        if (!id) return ''

        const marcoThickness = (_this.state.marcoThicknessMatriz || []).find(el => el.id === id)

        if (!marcoThickness) return ''

        return marcoThickness.get(attr)
    }

    const applyFixedAlizMatch = (ids, patternId) => {
        const { componentId, finishingId } = resolveAlizComponentMatch(ids.fixed)
        updateProductData('fixed_aliz', index, componentId)
        updateProductData('finishing_aliz', index, componentId)
        updateProductData('fixed_aliz_option_finishing', index, finishingId)
        updateProductData('pattern_aliz', index, componentId ? patternId : null)
    }

    const applyAdjustableAlizMatch = (ids, patternId) => {
        const { componentId, finishingId } = resolveAlizComponentMatch(ids.adjustable)
        updateProductData('adjustable_aliz', index, componentId)
        updateProductData('finishing_aliz_adjustable', index, componentId)
        updateProductData('adjustable_aliz_option_finishing', index, finishingId)
        updateProductData('pattern_aliz_adjustable', index, componentId ? patternId : null)
    }

    // If the material frame is different from wood, do not display the alizar options
    if(getProductValue('marco_material') !== 'Madeira') return null

    return (
        <Fragment>
            <Row gutter={12} className="chunk">
                <h2>Cadastro de Arremates</h2>
            </Row>
            <Row gutter={24}>
                <Col span={3}>
                    <Form.Item label='Face'>
                        <div style={{ fontWeight: 'bold' }}>
                            Fixa
                        </div>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Alizar">
                        <Select
                            value={getProductValue('aliz_fixed_section_')}
                            onChange={value => {
                                const valueNumber = parseInt(value.replace('x', '').replace('-', ''))
                                const alizType = valueNumber < 100 ? 'component_kit' : 'component_kit_fusion_frame'
                                updateProductData('aliz_fixed_type', index, alizType)
                                updateProductData('aliz_fixed_section', index, value) // Atribuir o valor do alizar_ para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('aliz_fixed_section_', index, value)

                                // Resetar os valores
                                updateProductData('fixed_aliz', index, null)
                                updateProductData('finishing_aliz', index, null)
                                updateProductData('pattern_aliz', index, null)

                                const finishingId = valueNumber < 100 ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: value.toString(), adjustable: '' },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyFixedAlizMatch(
                                            ids,
                                            valueNumber < 100 ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        alizType
                                    })
                                }
                            }}
                            placeholder="Alizar" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                getAlizSectionValues(_this.state.alizMatriz, FIXED_FACE, ALIZ_RELATION_KEYS.alizar)
                                    .map(el => (
                                        <Select.Option value={`-${el}x`}>Alizar {el < 100 ? 'Standard' : 'Fusion frame'} {el}mm</Select.Option>
                                    ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Bandeira">
                        <Select
                            value={getProductValue('band_fixed_section')}
                            onChange={value => {
                                const valueNumber = parseInt(value.replace('x', '').replace('-', ''))
                                const alizType = valueNumber < 100 ? 'component_kit_with_band' : 'component_kit_with_band_fusion_frame'
                                updateProductData('aliz_fixed_type', index, alizType)
                                updateProductData('aliz_fixed_section', index, value) // Atribuir o valor da bandeira para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('band_fixed_section', index, value)

                                // Resetar os valores
                                updateProductData('fixed_aliz', index, null)
                                updateProductData('finishing_aliz', index, null)
                                updateProductData('pattern_aliz', index, null)

                                const finishingId = valueNumber < 100 ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: value.toString(), adjustable: '' },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyFixedAlizMatch(
                                            ids,
                                            valueNumber < 100 ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        alizType
                                    })
                                }
                            }}
                            placeholder="Bandeira" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                getAlizSectionValues(_this.state.alizMatriz, FIXED_FACE, ALIZ_RELATION_KEYS.band)
                                    .map(el => (
                                        <Select.Option value={`-${el}x`}>Bandeira {el < 100 ? 'falsa c/ alizar Standard' : 'Fusion frame c/ alizar'} {el}mm</Select.Option>
                                    ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Painel">
                        <Select
                            value={getProductValue('panel_fixed_section')}
                            onChange={value => {
                                const alizType = !value.includes('_fusion-frame') ? 'component_kit_with_panel' : 'component_kit_with_panel_fusion_frame'
                                const isFusionFrame = value.includes('_fusion-frame')
                                updateProductData('aliz_fixed_type', index, alizType)
                                updateProductData('aliz_fixed_section', index, value) // Atribuir o valor do painel para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('panel_fixed_section', index, value)

                                // Resetar os valores
                                updateProductData('fixed_aliz', index, null)
                                updateProductData('finishing_aliz', index, null)
                                updateProductData('pattern_aliz', index, null)

                                const finishingId = !isFusionFrame ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    const sectionValue = value.replace('_fusion-frame', '')
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: sectionValue.toString(), adjustable: '' },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyFixedAlizMatch(
                                            ids,
                                            !isFusionFrame ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        alizType,
                                    })
                                }
                            }}
                            placeholder="Painel" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                hasAlizPanelOptions(_this.state.alizMatriz, FIXED_FACE, ALIZ_RELATION_KEYS.panel)
                                    ? ['-15x', '-15x_fusion-frame'].map(el => <Select.Option value={el}>Painel {el === '-15x' ? 'Fusion' : 'Fusion frame'} 1800x15mm</Select.Option>)
                                    : null
                            }
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={3}>
                    <Form.Item label='Face'>
                        <div style={{ fontWeight: 'bold' }}>
                            Regulável
                        </div>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Alizar">
                        <Select
                            value={getProductValue('aliz_adjustable_section_')}
                            onChange={async value => {
                                const valueNumber = parseInt(value.replace('x', '').replace('-', ''))
                                const alizType = valueNumber < 100 ? 'component_kit' : 'component_kit_fusion_frame'
                                updateProductData('aliz_adjustable_type', index, alizType)
                                updateProductData('aliz_adjustable_section', index, value) // Atribuir o valor do alizar_ para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('aliz_adjustable_section_', index, value)

                                // Resetar os valores
                                updateProductData('adjustable_aliz', index, null)
                                updateProductData('finishing_aliz_adjustable', index, null)
                                updateProductData('pattern_aliz_adjustable', index, null)

                                const finishingId = valueNumber < 100 ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: '', adjustable: value.toString() },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyAdjustableAlizMatch(
                                            ids,
                                            valueNumber < 100 ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        adjustableType: getMarcoThicknessInfo(getProductValue('wall_thickness'), 'adjustable_aliz'),
                                        alizType,
                                    })
                                }
                            }}
                            placeholder="Alizar" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                getAlizSectionValues(_this.state.alizMatriz, ADJUSTABLE_FACE, ALIZ_RELATION_KEYS.alizar)
                                    .map(el => (
                                        <Select.Option value={`-${el}x`}>Alizar {el < 100 ? 'Standard' : 'Fusion frame'} {el}mm</Select.Option>
                                    ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Bandeira">
                        <Select
                            value={getProductValue('band_adjustable_section')}
                            onChange={async value => {
                                const valueNumber = parseInt(value.replace('x', '').replace('-', ''))
                                const alizType = valueNumber < 100 ? 'component_kit_with_band' : 'component_kit_with_band_fusion_frame'
                                updateProductData('aliz_adjustable_type', index, alizType)
                                updateProductData('aliz_adjustable_section', index, value) // Atribuir o valor da bandeira para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('band_adjustable_section', index, value)

                                // Resetar os valores
                                updateProductData('adjustable_aliz', index, null)
                                updateProductData('finishing_aliz_adjustable', index, null)
                                updateProductData('pattern_aliz_adjustable', index, null)

                                const finishingId = valueNumber < 100 ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: '', adjustable: value.toString() },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyAdjustableAlizMatch(
                                            ids,
                                            valueNumber < 100 ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        adjustableType: getMarcoThicknessInfo(getProductValue('wall_thickness'), 'adjustable_aliz'),
                                        alizType,
                                    })
                                }
                            }}
                            placeholder="Bandeira" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                getAlizSectionValues(_this.state.alizMatriz, ADJUSTABLE_FACE, ALIZ_RELATION_KEYS.band)
                                    .map(el => (
                                        <Select.Option value={`-${el}x`}>Bandeira {el < 100 ? 'falsa c/ alizar Standard' : 'Fusion frame c/ alizar'} {el}mm</Select.Option>
                                    ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item label="Painel">
                        <Select
                            value={getProductValue('panel_adjustable_section')}
                            onChange={async value => {
                                const alizType = !value.includes('_fusion-frame') ? 'component_kit_with_panel' : 'component_kit_with_panel_fusion_frame'
                                const isFusionFrame = value.includes('_fusion-frame')
                                updateProductData('aliz_adjustable_type', index, alizType)
                                updateProductData('aliz_adjustable_section', index, value) // Atribuir o valor do painel para o alizar, pois é o que será utilizado na função de setAlizFinishingEqualMarco
                                updateProductData('panel_adjustable_section', index, value)

                                // Resetar os valores
                                updateProductData('adjustable_aliz', index, null)
                                updateProductData('finishing_aliz_adjustable', index, null)
                                updateProductData('pattern_aliz_adjustable', index, null)

                                const finishingId = !isFusionFrame ?
                                    ((getProductValue('finishing_marco') && getProductValue('marco_option_finishing')) ? getProductValue('marco_option_finishing') : null) :
                                    ((getProductValue('finishing_sheet') && getProductValue('sheet_option_finishing')) ? getProductValue('sheet_option_finishing') : null)

                                if (value) {
                                    const sectionValue = value.replace('_fusion-frame', '')
                                    setAlizFinishingEqualMarco({
                                        alizMatriz: _this.state.alizMatriz,
                                        marcoComponents: _this.state.kitsComponents['comp_marco'],
                                        marcoId: getProductValue('finishing_marco'),
                                        finishingId: finishingId,
                                        sections: { fixed: '', adjustable: sectionValue.toString() },
                                        panelFlag: getProductValue('aliz_options_02'),
                                        updateFunction: (ids) => applyAdjustableAlizMatch(
                                            ids,
                                            !isFusionFrame ? getProductValue('pattern_marco') : getProductValue('pattern_sheet'),
                                        ),
                                        newMethodology: true,
                                        adjustableType: getMarcoThicknessInfo(getProductValue('wall_thickness'), 'adjustable_aliz'),
                                        alizType,
                                    })
                                }
                            }}
                            placeholder="Painel" size="large"
                            disabled={_this.props.disabledFields}
                        >
                            <Select.Option value=''>Selecione...</Select.Option>
                            {
                                hasAlizPanelOptions(_this.state.alizMatriz, ADJUSTABLE_FACE, ALIZ_RELATION_KEYS.panel)
                                    ? ['-15x', '-15x_fusion-frame'].map(el => <Select.Option value={el}>Painel {el === '-15x' ? 'Fusion' : 'Fusion frame'} 1800x15mm</Select.Option>)
                                    : null
                            }
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Divider dashed={true} />
        </Fragment>
    )
}

export default productStepAlizar